const STATE = 'state'

module.exports = {
  STATE
}
